import {ManagedScene} from "../drawfrm/Scene";
import {ElevationApp} from "../ElevationApp";

export class ManagedScene2 extends ManagedScene {
    elev: ElevationApp

    constructor(param: ElevationApp) {
        super();

        this.elev = param;
    }
}